import { FC } from "react";
import { useStyles } from "./styles";
import { BarChart } from "@mui/x-charts";
import { Box } from "@material-ui/core";
import { formatNumber } from "utils/formatNumbers";

interface LineChartTempProps {
  dataset: any;
  xAxis: any;
  yAxis: any;
  series: any;
  margin: any;
  height: number;
  layout: "horizontal" | "vertical";
}

export const BarChartElem: FC<LineChartTempProps> = ({
  dataset,
  xAxis,
  yAxis,
  series,
  margin,
  height,
  layout,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.chartBox}>
      <BarChart
        className={classes.barChart}
        dataset={dataset || []}
        barLabel={(item: any, context: any) => `${formatNumber(item.value)}`}
        xAxis={xAxis}
        yAxis={yAxis}
        series={series}
        layout={layout}
        height={height}
        margin={margin}
        slotProps={{
          legend: {
            hidden: true,
          },
          popper: {
            placement: "top",
          },
        }}
        sx={{
          "& .MuiBarLabel-root": {
            fill: "#ffffff",
            fontWeight: "bold",
            fontSize: "12px",
          },
        }}
      />
    </Box>
  );
};
